var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{attrs:{"label":_vm.$t(_vm.input.label)},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }